export function downloadTextFile(text: string, filename: string) {
	const blob = new Blob([text]);
	const link = document.createElement("a");
	link.href = URL.createObjectURL(blob);
	link.download = filename;
	link.click();
}
